import React, { createContext, useContext, useMemo, useState } from 'react';
import { LoginClientSummary } from '../../Services/LoginService';

export interface LoginContextValue {
	clients: LoginClientSummary[] | null;
	setClients: (clients: LoginClientSummary[] | null) => void;
	fatalError: string | null;
	setFatalError: (message: string | null) => void;
}

const LoginStateContext = createContext<LoginContextValue | undefined>(undefined);

export const useLoginState = () => {
	const ctx = useContext(LoginStateContext);
	if (!ctx) {
		throw new Error('Login state must be used within LoginStateProvider');
	}
	return ctx;
};

export const LoginStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [clients, setClients] = useState<LoginClientSummary[] | null>(null);
	const [fatalError, setFatalError] = useState<string | null>(null);

	const value = useMemo(() => ({ clients, setClients, fatalError, setFatalError }), [clients, fatalError]);

	return <LoginStateContext.Provider value={value}>{children}</LoginStateContext.Provider>;
};
